import _filter from "lodash/filter"
import _sumBy from "lodash/sumBy"
import _map from "lodash/map"
import _merge from "lodash/merge"
import _uniq from "lodash/uniq"
import _max from "lodash/max"


export default class TicketFeeCalculator {

    constructor(fees) {
        this.fees = fees;
    }

    setFinalPrice(finalPrice) {
        this.finalPrice = finalPrice;

        return this;
    }

    setBasePrice(basePrice) {
        this.basePrice = basePrice;

        return this;
    }

    getFinalPrice() {
        let fees = _filter(this.fees, (fee) => {
            return this.basePrice >= fee.min_price && this.basePrice < fee.max_price;
        });

        return Math.round(this.basePrice * (1 + _sumBy(fees, 'percent')) + _sumBy(fees, 'absolute'));
    }

    getBasePrice() {
        let interpolationTable = this.buildInterpolationTable()

        return Math.round(_max(_map(interpolationTable, (value, key) => {
            if (this.finalPrice >= interpolationTable[key].leftBorder && this.finalPrice < interpolationTable[key + 1].rightBorder) {
                return (this.finalPrice - interpolationTable[key].leftBorder) / interpolationTable[key].slope + interpolationTable[key].basePrice
            } else if (this.finalPrice <= interpolationTable[key].leftBorder && this.finalPrice >= interpolationTable[key].rightBorder) {
                return interpolationTable[key].basePrice;
            }
        })))
    }

    calculateBorders(basePrice) {
        let feesLeft = _filter(this.fees, (fee) => {
            return basePrice >= fee.min_price && basePrice < fee.max_price
        });

        let feesRight = _filter(this.fees, (fee) => {
            return basePrice > fee.min_price && basePrice <= fee.max_price
        });

        return {
            leftBorder: basePrice * (1 + _sumBy(feesLeft, 'percent')) + _sumBy(feesLeft, 'absolute'),
            rightBorder: basePrice * (1 + _sumBy(feesRight, 'percent')) + _sumBy(feesRight, 'absolute'),
            slope: 1 + _sumBy(feesLeft, 'percent'),
            basePrice: basePrice
        }
    }

    buildInterpolationTable() {

        let min_prices = _map(this.fees, 'min_price')
        let max_prices = _map(this.fees, 'max_price')


        return _map(_uniq([...min_prices, ...max_prices].sort((a, b) => a - b)), (key) => {
            return this.calculateBorders(key);
        });
    }

}